import React, { useState } from "react";
import { PlusCircle } from "lucide-react";
import CreateAttributeDialog from "./Dialogs/CreateAttributeDialog.tsx";

interface CanvasHeaderProps {
    saveChanges: () => void;
    flowName: string;
    setFlowName: (name: string) => void;
    btnLoading: boolean;
}

const CanvasHeader: React.FC<CanvasHeaderProps> = ({ saveChanges, flowName, setFlowName, btnLoading }) => {
    const [isAttrDialogOpen, setIsAttrDialogOpen] = useState(false);

    // right is offset by the width of the back button the dashboard overlays on this corner
    // (42px + 10px gutter), so the toolbar keeps clear of it.
    return (
        <div style={{ position: 'fixed', right: '62px', top: '10px', zIndex: 1000, display: 'flex', height: '42px', gap: '10px', alignItems: 'center' }}>
            <input 
                className="flow-name" 
                type="text" 
                placeholder="Flow name" 
                onChange={(event) => setFlowName(event.target.value)} 
                value={flowName} 
                style={{ width: '200px', height: '100%', fontSize: '14px', padding: '0 12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
            />
            
            <button 
                className="new-attr-btn" 
                onClick={() => setIsAttrDialogOpen(true)}
                style={{ 
                    height: '100%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '6px', 
                    padding: '0 16px', 
                    background: '#ffffff', 
                    color: 'var(--primary-bg-color)', 
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '11px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    whiteSpace: 'nowrap'
                }}
            >
                <PlusCircle size={14} />
                New Variable
            </button>

            {
                !btnLoading ?
                <button 
                    className="save-btn" 
                    onClick={saveChanges} 
                    style={{ height: '100%', padding: '0 24px', whiteSpace: 'nowrap', borderRadius: '8px', fontSize: '11px', fontWeight: 600 }}
                >
                    Save Changes
                </button>
                : 
                <button 
                    disabled 
                    className="save-btn" 
                    style={{ height: '100%', padding: '0 24px', opacity: 0.5, whiteSpace: 'nowrap', borderRadius: '8px', fontSize: '11px', fontWeight: 600 }}
                >
                    <i className="fa fa-circle-o-notch fa-spin mr-2"></i>
                    Loading...
                </button>
            }

            <CreateAttributeDialog 
                isOpen={isAttrDialogOpen} 
                onClose={() => setIsAttrDialogOpen(false)} 
            />
        </div>
    )
};

export default CanvasHeader;
